import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Grid,
  TextField,
} from '@material-ui/core';
import { get, isEmpty } from 'lodash';
import { IntlShape, injectIntl } from 'react-intl';
import styled from 'styled-components';

import { translate } from 'containers/services/translate';

import { COLORS } from 'constants/design';

import PrimaryButton from 'components/Buttons/PrimaryButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import { CivilProceedingInfo } from 'containers/LawyerLegalProceedingsPage/typings';

import messages from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/messages';

const StyledDiv = styled.div`
  width: 576px;
  display: flex;
  align-items: center;
  justify-content: center;

  .select {
    width: 100%;
    margin-bottom: 33px;
    font-size: 13px;
  }
`;
const StyledDialogActions = styled(DialogActions)`
  display: flex;
  padding: 20px 30px;
  justify-content: space-between;

  .moveButton {
    border: 1px solid ${COLORS.YELLOW};
    background-color: ${COLORS.YELLOW};
    color: ${COLORS.LIMED_SPURCE};
    &:hover {
      background-color: ${COLORS.YELLOW};
    }
  }

  .Mui-disabled {
    opacity: 0.6;
  }
`;

export interface RejectionDialogProps {
  intl: IntlShape;
  open: boolean;
  onClose: Function;
  setCivilProceedingInfo: Function;
  handleValidation: any;
  civilProceedingInfo: CivilProceedingInfo;
  judiciaryProcessId: number;
}

const RejectionDialog: React.FC<RejectionDialogProps> = (
  props,
): JSX.Element => {
  const { onClose, open } = props;

  const handleClose = () => {
    onClose();
  };

  const handleChange = (
    e: React.ChangeEvent<{ value: string; name: string }>,
  ) => {
    props.setCivilProceedingInfo({
      ...props.civilProceedingInfo,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <DialogTitle id="simple-dialog-title">
        {translate({ ...messages.rejectionReason }, props)}
      </DialogTitle>
      <DialogContent>
        <StyledDiv>
          <Grid container direction="column" spacing={2}>
            <Grid item xs={8}>
              <TextField
                className="select"
                label={translate(messages.rejectionReason, props)}
                name={'rejectionReason'}
                id={'rejectionReason'}
                value={get(props.civilProceedingInfo, 'rejectionReason', '')}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
          </Grid>
        </StyledDiv>
      </DialogContent>
      <StyledDialogActions>
        <SecondaryButton
          onClick={handleClose}
          disableElevation
          title={translate({ ...messages.cancelButton }, props)}
        />
        <PrimaryButton
          onClick={props.handleValidation}
          disabled={isEmpty(
            get(props, 'civilProceedingInfo.rejectionReason', ''),
          )}
          title={translate({ ...messages.validationButton }, props)}
        />
      </StyledDialogActions>
    </Dialog>
  );
};

RejectionDialog.defaultProps = {
  open: false,
};

export default injectIntl(RejectionDialog);
